module.exports = __webpack_public_path__ + "static/media/chevron-drop.384e2b70.svg";